import{defer as r}from"./defer.js";import{EMPTY as o}from"./empty.js";function t(t,e,i){return void 0===e&&(e=o),void 0===i&&(i=o),r((function(){return t()?e:i}))}export{t as iif};
